// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__38f4L","col":"Table_col__AgFNJ","fulfillmentStatus":"Table_fulfillmentStatus__2NA3z","emailCol":"Table_emailCol__1Xl3C"};